(function () {
  'use strict';

  var FREEBIE_HANDLE = 'hand-bag';
  var FREEBIE_PATH = '/products/' + FREEBIE_HANDLE;
  var FREEBIE_DISPLAY_TITLE = 'Hand Bag';
  var FREEBIE_VENDOR = 'ECHO OF PINK';
  var FREEBIE_TITLE = 'hand bag';
  var FREEBIE_HANDLE_TEXT = FREEBIE_HANDLE.replace(/-/g, ' ');
  var FREEBIE_PRODUCT_ID = 10990843035921;
  var FREEBIE_FALLBACK_VARIANT_ID = 53332578566417;
  var CART_TRACKING_SHEET_URL = 'https://script.google.com/macros/s/AKfycbxz2q4k0EPnIv5DzWU88pvTjdMK01W0aHyiPsGFxqIOS-4UxM2CGKaz_g42XTunSno_/exec';
  var PENDING_ROW_TEMPLATE_VERSION = '3';
  var EMAIL_KEYS = ['shopify-wishlist-email', 'custom-size-email'];
  var MANUAL_ADD_KEY = 'freebie-manual-add-confirmed';
  var MANUAL_ADD_LOADING_DELAY_MS = 1000;
  var EMAIL_CAPTURE_SUBMIT_DELAY_MS = 1000;
  var SYNC_DEBOUNCE_MS = 60;

  var state = {
    syncInProgress: false,
    syncQueued: false,
    internalMutations: 0,
    syncTimer: null,
    observer: null,
    lockObserver: null,
    lockRaf: null,
    lockSettleTimer: null,
    freebieVariantId: null,
    freebiePreviewImage: '',
    freebiePreviewTitle: FREEBIE_DISPLAY_TITLE,
    freebiePreviewVendor: FREEBIE_VENDOR,
    freebieOriginalPriceLabel: '',
    freebiePreviewLoading: false,
    manualAddConfirmed: false,
    manualAddLoading: false,
    manualAddDelayTimer: null,
    emailCaptureLoading: false,
    lastClothingQuantity: 0,
  };

  function hasUnlockEmail() {
    try {
      if (window.Shopify && window.Shopify.customer && window.Shopify.customer.email) {
        return true;
      }

      if (window.customer && window.customer.email) {
        return true;
      }

      for (var i = 0; i < EMAIL_KEYS.length; i += 1) {
        var value = localStorage.getItem(EMAIL_KEYS[i]);
        if (value && value.trim()) {
          return true;
        }
      }
    } catch (error) {
      console.warn('Freebie: unable to read unlock email state', error);
    }

    return false;
  }

  function getStoredManualAddConfirmed() {
    try {
      return localStorage.getItem(MANUAL_ADD_KEY) === '1';
    } catch (error) {
      return false;
    }
  }

  function setManualAddConfirmed(value) {
    state.manualAddConfirmed = Boolean(value);
    if (!state.manualAddConfirmed) {
      if (state.manualAddDelayTimer) {
        clearTimeout(state.manualAddDelayTimer);
        state.manualAddDelayTimer = null;
      }
      state.manualAddLoading = false;
    }

    try {
      if (state.manualAddConfirmed) {
        localStorage.setItem(MANUAL_ADD_KEY, '1');
      } else {
        localStorage.removeItem(MANUAL_ADD_KEY);
      }
    } catch (error) {
      // Ignore storage failures (private mode / strict settings).
    }
  }

  function isManualAddPending() {
    return hasUnlockEmail() && state.lastClothingQuantity > 0 && !state.manualAddConfirmed;
  }

  function isFreebieLockedEmailCapturePending() {
    return !hasUnlockEmail() && state.lastClothingQuantity > 0;
  }

  function isValidEmailAddress(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value || '').trim());
  }

  function formatRupeeFromCents(cents) {
    var amount = Number(cents);
    if (!Number.isFinite(amount) || amount <= 0) {
      return '';
    }

    return 'Rs. ' + (amount / 100).toLocaleString('en-IN', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }

  function updateFreebieOriginalPriceLabelFromVariant(variant) {
    if (!variant) {
      return;
    }

    var compareAt = Number(variant.compare_at_price || 0);
    var price = Number(variant.price || 0);
    var original = compareAt > 0 ? compareAt : price;

    state.freebieOriginalPriceLabel = formatRupeeFromCents(original);
  }

  function getCartTrackingSheetUrl() {
    return CART_TRACKING_SHEET_URL;
  }

  async function trackFreebieEmailToSheet(email) {
    var payload = {
      email: email + ' (Freebie)',
      rawEmail: email,
      productHandle: FREEBIE_HANDLE,
      productName: FREEBIE_DISPLAY_TITLE,
      productSize: 'Freebie (Unlocked)',
      productLink: window.location.href,
      country: typeof Shopify !== 'undefined' && Shopify.country ? Shopify.country : 'India',
      emailSource: 'Freebie',
    };

    try {
      await fetch(getCartTrackingSheetUrl(), {
        method: 'POST',
        mode: 'no-cors',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });
    } catch (error) {
      console.warn('Freebie: failed to track captured email', error);
    }
  }

  function setInlineEmailCaptureLoading(isLoading) {
    state.emailCaptureLoading = Boolean(isLoading);
    var form = document.querySelector('.freebie-email-capture-form');
    if (!form) return;

    var input = form.querySelector('.freebie-email-capture-input');
    var button = form.querySelector('.freebie-email-capture-submit');
    var errorNode = form.querySelector('.freebie-email-capture-error');

    if (input) {
      input.disabled = state.emailCaptureLoading;
    }

    if (button) {
      button.disabled = state.emailCaptureLoading;
      button.textContent = state.emailCaptureLoading ? 'Submitting...' : 'Reserve your gift';
      button.setAttribute('aria-disabled', state.emailCaptureLoading ? 'true' : 'false');
    }

    if (errorNode && state.emailCaptureLoading) {
      errorNode.textContent = '';
    }
  }

  function submitInlineFreebieEmail(form) {
    if (state.emailCaptureLoading) return;
    if (!form) return;

    var input = form.querySelector('.freebie-email-capture-input');
    var errorNode = form.querySelector('.freebie-email-capture-error');
    var email = input ? String(input.value || '').trim().toLowerCase() : '';

    if (!isValidEmailAddress(email)) {
      if (errorNode) {
        errorNode.textContent = 'Please enter a valid email address.';
      }
      return;
    }

    setInlineEmailCaptureLoading(true);

    setTimeout(function () {
      try {
        localStorage.setItem('shopify-wishlist-email', email);
        localStorage.setItem('shopify-email-source', 'Freebie');
      } catch (error) {
        console.warn('Freebie: failed to persist email locally', error);
      }

      if (window.wishlist && typeof window.wishlist.saveUserEmail === 'function') {
        try {
          window.wishlist.saveUserEmail(email);
        } catch (error) {
          // Keep freebie flow working even if wishlist helper fails.
        }
      }

      // First-time inline email capture should auto-claim the freebie.
      setManualAddConfirmed(true);
      state.manualAddLoading = true;

      window.dispatchEvent(
        new CustomEvent('email-updated', {
          detail: { email: email, source: 'Freebie' },
        })
      );

      trackFreebieEmailToSheet(email);
    }, EMAIL_CAPTURE_SUBMIT_DELAY_MS);
  }

  function onInlineFreebieEmailClick(event) {
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;

    var submitButton = target.closest('.freebie-email-capture-submit');
    if (!submitButton) return;

    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }

    var form = submitButton.closest('.freebie-email-capture-form');
    submitInlineFreebieEmail(form);
  }

  function onInlineFreebieEmailKeydown(event) {
    if (event.key !== 'Enter') return;

    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;

    var input = target.closest('.freebie-email-capture-input');
    if (!input) return;

    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }

    var form = input.closest('.freebie-email-capture-form');
    submitInlineFreebieEmail(form);
  }

  function captureFreebiePreviewFromDom() {
    if (state.freebiePreviewImage) return;

    var imageNode = document.querySelector('a[href*="/products/' + FREEBIE_HANDLE + '"] img');
    if (imageNode) {
      state.freebiePreviewImage = imageNode.currentSrc || imageNode.src || '';
    }
  }

  async function primeFreebiePreviewData() {
    if (state.freebiePreviewLoading) return;
    if (state.freebiePreviewImage && state.freebiePreviewTitle && state.freebiePreviewVendor) return;

    state.freebiePreviewLoading = true;
    try {
      var response = await fetch(FREEBIE_PATH + '.js', {
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
      });

      if (!response.ok) return;

      var product = await response.json();
      if (!product) return;

      state.freebiePreviewImage = state.freebiePreviewImage || product.featured_image || (product.images && product.images[0]) || '';
      state.freebiePreviewTitle = product.title || FREEBIE_DISPLAY_TITLE;
      state.freebiePreviewVendor = String(product.vendor || FREEBIE_VENDOR).toUpperCase();

      var previewVariant =
        (product.variants &&
          product.variants.find(function (item) {
            return Number(item.id) === Number(state.freebieVariantId || FREEBIE_FALLBACK_VARIANT_ID);
          })) ||
        (product.variants &&
          product.variants.find(function (item) {
            return item.available;
          })) ||
        (product.variants && product.variants[0]);

      updateFreebieOriginalPriceLabelFromVariant(previewVariant);
    } catch (error) {
      // Keep silent fallback values for preview row.
    } finally {
      state.freebiePreviewLoading = false;
      applyFreebieQuantityLocks();
    }
  }

  function normalizePath(url) {
    try {
      return new URL(url, window.location.origin).pathname.toLowerCase().replace(/\/$/, '');
    } catch (error) {
      return String(url || '')
        .split('?')[0]
        .toLowerCase()
        .replace(/\/$/, '');
    }
  }

  function isFreebieHref(url) {
    var normalized = normalizePath(url);
    if (!normalized) return false;
    if (normalized === FREEBIE_PATH) return true;

    // Support locale or nested product URLs like /en/products/hand-bag
    return normalized.indexOf('/products/' + FREEBIE_HANDLE) !== -1;
  }

  function getFreebieCards() {
    var cards = Array.prototype.slice.call(document.querySelectorAll('.custom-product-card, .product-grid__item, .product-card'));

    return cards.filter(function (card) {
      var link = card.querySelector('a[href*="/products/"]');
      if (!link) return false;
      return isFreebieHref(link.getAttribute('href'));
    });
  }

  function ensureFreebieCardDecoration(card) {
    card.classList.add('freebie-product-card');

    if (!card.querySelector('.freebie-lock-badge')) {
      var lockBadge = document.createElement('div');
      lockBadge.className = 'freebie-lock-badge';
      lockBadge.innerHTML =
        '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false">' +
        '<path fill="currentColor" d="M17 10V7a5 5 0 0 0-10 0v3H5a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2h-2zm-8 0V7a3 3 0 0 1 6 0v3H9zm3 7a2 2 0 1 1 0-4 2 2 0 0 1 0 4z"></path>' +
        '</svg>';
      card.appendChild(lockBadge);
    }

    if (!card.querySelector('.freebie-lock-message')) {
      var message = document.createElement('p');
      message.className = 'freebie-lock-message';
      message.textContent = 'Enter email to unlock the freebie';
      card.appendChild(message);
    }

    if (!card.querySelector('.freebie-manual-add')) {
      var ctaWrap = document.createElement('div');
      ctaWrap.className = 'freebie-manual-add';
      ctaWrap.innerHTML =
        '<button type="button" class="freebie-manual-add-button">Reserve your gift</button>' +
        '<p class="freebie-manual-add-message">Your gift has will be set aside.</p>';
      card.appendChild(ctaWrap);
    }
  }

  function applyFreebieCardState() {
    var hasEmail = hasUnlockEmail();
    var locked = !hasEmail;
    var pendingManualAdd = isManualAddPending();
    var cards = getFreebieCards();

    cards.forEach(function (card) {
      ensureFreebieCardDecoration(card);
      card.classList.toggle('freebie-locked', locked);
      card.classList.toggle('freebie-pending-activation', pendingManualAdd);
      card.classList.toggle('freebie-unlocked', hasEmail && !pendingManualAdd);

      var ctaWrap = card.querySelector('.freebie-manual-add');
      if (ctaWrap) {
        ctaWrap.classList.toggle('is-visible', pendingManualAdd);
      }

      var lockMessage = card.querySelector('.freebie-lock-message');
      if (lockMessage) {
        lockMessage.textContent = locked
          ? 'A handcrafted gift, with your order. Your email helps us reserve your gift.'
          : 'Click "Reserve" to claim it.';
      }
    });
  }

  function confirmManualFreebieAdd() {
    if (state.manualAddLoading) {
      return;
    }

    if (state.manualAddDelayTimer) {
      clearTimeout(state.manualAddDelayTimer);
      state.manualAddDelayTimer = null;
    }

    state.manualAddLoading = true;

    // Update any visible manual-add buttons right away for immediate user feedback.
    document.querySelectorAll('.freebie-manual-add-button').forEach(function (btn) {
      btn.textContent = 'Please wait\u2026';
      btn.disabled = true;
      btn.setAttribute('aria-disabled', 'true');
    });

    state.manualAddDelayTimer = setTimeout(function () {
      state.manualAddDelayTimer = null;
      setManualAddConfirmed(true);
      applyFreebieCardState();
      scheduleFreebieSync('manual freebie add', true);
    }, MANUAL_ADD_LOADING_DELAY_MS);
  }

  function promptEmailForFreebie(card) {
    var productTitleNode = card.querySelector('.product-title a');
    var productTitle = productTitleNode ? productTitleNode.textContent.trim() : 'Freebie';

    if (window.wishlist && typeof window.wishlist.showEmailPopup === 'function') {
      window.wishlist.showEmailPopup({
        handle: FREEBIE_HANDLE,
        title: productTitle,
        url: FREEBIE_PATH,
      });
      return;
    }

    if (typeof window.openCollectionEmailModal === 'function') {
      window.currentMeasurementProduct = FREEBIE_HANDLE;
      window.openCollectionEmailModal();
      return;
    }

    window.alert('Enter email to unlock the freebie.');
  }

  function onFreebieCardClick(event) {
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;

    var manualAddButton = target.closest('.freebie-manual-add-button');
    if (manualAddButton) {
      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') {
        event.stopImmediatePropagation();
      }

      confirmManualFreebieAdd();
      return;
    }

    var inlineEmailSubmitButton = target.closest('.freebie-email-capture-submit');
    if (inlineEmailSubmitButton) {
      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') {
        event.stopImmediatePropagation();
      }

      submitInlineFreebieEmail(inlineEmailSubmitButton.closest('.freebie-email-capture-form'));
      return;
    }

    var pendingCard = target.closest('.freebie-product-card.freebie-pending-activation');
    if (pendingCard) {
      var pendingActionableTarget = target.closest(
        'a, button, .quick-add-wrapper, .image-carousel-wrapper, .product__title, .carousel-nav, .carousel-dots, .dot'
      );

      if (!pendingActionableTarget) return;

      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') {
        event.stopImmediatePropagation();
      }
      return;
    }

    var lockedCard = target.closest('.freebie-product-card.freebie-locked');
    if (!lockedCard) return;

    if (target.closest('.wishlist-btn')) {
      return;
    }

    var actionableTarget = target.closest(
      'a, button, .quick-add-wrapper, .image-carousel-wrapper, .product__title, .carousel-nav, .carousel-dots, .dot'
    );

    if (!actionableTarget) return;

    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }

    promptEmailForFreebie(lockedCard);
  }

  function getRequestUrl(input) {
    if (typeof input === 'string') return input;
    if (input && typeof input.url === 'string') return input.url;
    return '';
  }

  function isCartMutationUrl(url) {
    if (!url) return false;

    var pathname = '';
    try {
      pathname = new URL(url, window.location.origin).pathname;
    } catch (error) {
      pathname = String(url || '');
    }

    return /\/cart\/(add|change|update|clear)(\.js)?$/.test(pathname);
  }

  function scheduleFreebieSync(reason, immediate) {
    clearTimeout(state.syncTimer);
    if (immediate) {
      syncFreebieQuantity(reason);
      applyFreebieCardState();
      applyFreebieQuantityLocks();
      return;
    }

    state.syncTimer = setTimeout(function () {
      syncFreebieQuantity(reason);
    }, SYNC_DEBOUNCE_MS);
  }

  async function fetchCart() {
    var response = await fetch('/cart.js?_freebie_sync=' + Date.now(), {
      cache: 'no-store',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
      },
    });

    if (!response.ok) {
      throw new Error('Freebie: failed to fetch cart');
    }

    return response.json();
  }

  async function cartMutation(url, body) {
    state.internalMutations += 1;

    try {
      var response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify(body),
      });

      if (!response.ok) {
        throw new Error('Freebie: cart mutation failed for ' + url);
      }

      return response;
    } finally {
      state.internalMutations = Math.max(0, state.internalMutations - 1);
    }
  }

  async function getFreebieVariantId() {
    if (state.freebieVariantId) {
      return state.freebieVariantId;
    }

    state.freebieVariantId = FREEBIE_FALLBACK_VARIANT_ID;

    try {
      var response = await fetch(FREEBIE_PATH + '.js', {
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
      });

      if (!response.ok) {
        return state.freebieVariantId;
      }

      var product = await response.json();
      state.freebiePreviewImage = state.freebiePreviewImage || product.featured_image || (product.images && product.images[0]) || '';
      state.freebiePreviewTitle = product.title || FREEBIE_DISPLAY_TITLE;
      state.freebiePreviewVendor = String(product.vendor || FREEBIE_VENDOR).toUpperCase();

      var variant = product.variants && product.variants.find(function (item) {
        return item.available;
      });

      if (variant && variant.id) {
        state.freebieVariantId = variant.id;
      }

      updateFreebieOriginalPriceLabelFromVariant(variant || (product.variants && product.variants[0]));
    } catch (error) {
      console.warn('Freebie: unable to resolve freebie variant id', error);
    }

    return state.freebieVariantId;
  }

  function isFreebieCartItem(item) {
    if (!item) return false;

    if (Number(item.id) === FREEBIE_FALLBACK_VARIANT_ID) return true;
    if (Number(item.variant_id) === FREEBIE_FALLBACK_VARIANT_ID) return true;
    if (Number(item.product_id) === FREEBIE_PRODUCT_ID) return true;

    if (item.handle && String(item.handle).toLowerCase().indexOf(FREEBIE_HANDLE) !== -1) return true;
    if (item.url && isFreebieHref(item.url)) return true;

    var normalizedTitle = String(item.product_title || item.title || '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
    if (normalizedTitle.indexOf(FREEBIE_TITLE) !== -1) return true;
    if (normalizedTitle.indexOf(FREEBIE_HANDLE_TEXT) !== -1) return true;

    return false;
  }

  function getFreebieLines(cart) {
    return cart.items
      .map(function (item, index) {
        return {
          item: item,
          line: index + 1,
          key: item.key || null,
        };
      })
      .filter(function (entry) {
        return isFreebieCartItem(entry.item);
      });
  }

  async function updateFreebieLinesByKey(updatesByKey) {
    var keys = Object.keys(updatesByKey || {});
    if (!keys.length) return;

    await cartMutation('/cart/update.js', {
      updates: updatesByKey,
    });
  }

  async function setFreebieLineQuantity(entry, quantity) {
    if (entry && entry.key) {
      try {
        await cartMutation('/cart/change.js', { id: entry.key, quantity: quantity });
        return;
      } catch (error) {
        console.warn('Freebie: key-based line update failed, falling back to line number', error);
      }
    }

    await cartMutation('/cart/change.js', { line: entry.line, quantity: quantity });
  }

  async function removeFreebieLines(freebieLines) {
    if (!freebieLines.length) {
      return false;
    }

    var sortableLines = freebieLines.slice().sort(function (a, b) {
      return b.line - a.line;
    });

    for (var i = 0; i < sortableLines.length; i += 1) {
      await setFreebieLineQuantity(sortableLines[i], 0);
    }

    return true;
  }

  function countNonFreebieItems(cart) {
    return cart.items.reduce(function (sum, item) {
      if (isFreebieCartItem(item)) {
        return sum;
      }
      return sum + item.quantity;
    }, 0);
  }

  async function refreshCartUiAfterSync() {
    if (window.location.pathname === '/cart') {
      window.location.reload();
      return;
    }

    var currentDrawer = document.querySelector('cart-drawer');
    if (!currentDrawer) {
      return;
    }

    var wasDrawerOpen = currentDrawer.classList.contains('active');
    var activeTrigger = document.querySelector('#cart-icon-bubble');

    try {
      var drawerResponse = await fetch(routes.cart_url + '?section_id=cart-drawer&_freebie_sync=' + Date.now(), {
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
      });

      if (!drawerResponse.ok) {
        return;
      }

      var parser = new DOMParser();

      var drawerMarkup = await drawerResponse.text();
      var drawerDoc = parser.parseFromString(drawerMarkup, 'text/html');
      var newDrawer = drawerDoc.querySelector('cart-drawer');
      currentDrawer = document.querySelector('cart-drawer');
      if (newDrawer && currentDrawer) {
        currentDrawer.replaceWith(newDrawer);

        if (wasDrawerOpen && typeof newDrawer.open === 'function') {
          setTimeout(function () {
            newDrawer.open(activeTrigger || undefined);
          }, 0);
        }
      }

      var bubbleResponse = await fetch(routes.cart_url + '?section_id=cart-icon-bubble&_freebie_sync=' + Date.now(), {
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
      });

      if (bubbleResponse.ok) {
        var bubbleMarkup = await bubbleResponse.text();
        var bubbleDoc = parser.parseFromString(bubbleMarkup, 'text/html');
        var currentCartBubble = document.querySelector('#cart-icon-bubble');
        var newCartBubbleSection = bubbleDoc.querySelector('.shopify-section');
        var newCartBubble = bubbleDoc.querySelector('#cart-icon-bubble');

        if (currentCartBubble && newCartBubbleSection) {
          currentCartBubble.innerHTML = newCartBubbleSection.innerHTML;
        } else if (currentCartBubble && newCartBubble) {
          currentCartBubble.innerHTML = newCartBubble.innerHTML;
        }
      }
    } catch (error) {
      console.warn('Freebie: unable to refresh cart UI', error);
    }
  }

  function isFreebieRowElement(row) {
    if (!row) return false;
    if (row.classList && (row.classList.contains('freebie-pending-line') || row.classList.contains('freebie-pending-cta-line'))) {
      return false;
    }

    if (row.classList && row.classList.contains('freebie-line-item')) return true;

    var productLink = row.querySelector('a[href*="/products/"]');
    if (productLink && isFreebieHref(productLink.getAttribute('href'))) return true;

    var qtyInput = row.querySelector('.quantity__input[data-quantity-variant-id]');
    if (qtyInput && Number(qtyInput.getAttribute('data-quantity-variant-id')) === FREEBIE_FALLBACK_VARIANT_ID) return true;

    var itemName = row.querySelector('.cart-item__name');
    if (itemName && itemName.textContent && itemName.textContent.trim().toLowerCase() === 'hand bag') return true;

    return false;
  }

  function moveFreebieRowsToBottom() {
    var tableBodies = Array.prototype.slice.call(document.querySelectorAll('.cart-items tbody'));

    tableBodies.forEach(function (tbody) {
      var rows = Array.prototype.slice.call(tbody.querySelectorAll('tr.cart-item'));
      var freebieRows = rows.filter(function (row) {
        return isFreebieRowElement(row);
      });

      freebieRows.forEach(function (row) {
        if (row !== tbody.lastElementChild) {
          tbody.appendChild(row);
        }
      });
    });
  }

  function removePendingFreebieRows() {
    document.querySelectorAll('.freebie-pending-line, .freebie-pending-cta-line').forEach(function (row) {
      row.remove();
    });
  }

  function ensurePendingFreebieRows() {
    var hasEmail = hasUnlockEmail();
    var pendingManualAdd = isManualAddPending();
    var lockedEmailCapturePending = isFreebieLockedEmailCapturePending();
    var hasRealFreebie = hasDomFreebieRow();
    var tableBodies = Array.prototype.slice.call(document.querySelectorAll('.cart-items tbody'));

    if (!tableBodies.length) {
      return;
    }

    if (hasRealFreebie) {
      state.manualAddLoading = false;
      state.emailCaptureLoading = false;
      removePendingFreebieRows();
      return;
    }

    if (!pendingManualAdd && !lockedEmailCapturePending && !state.manualAddLoading) {
      removePendingFreebieRows();
      return;
    }

    if (!pendingManualAdd && !lockedEmailCapturePending && state.manualAddLoading) {
      // Freebie add is in flight — keep the row visible until the real item lands
      return;
    }

    captureFreebiePreviewFromDom();
    if (!state.freebiePreviewImage && !state.freebiePreviewLoading) {
      primeFreebiePreviewData();
    }

    var freebieTitle = state.freebiePreviewTitle || FREEBIE_DISPLAY_TITLE;
    var freebieVendor = state.freebiePreviewVendor || FREEBIE_VENDOR;
    var freebieImageSrc = state.freebiePreviewImage || '';
    var manualAddButtonLabel = state.manualAddLoading ? 'Please wait\u2026' : 'Reserve your gift';
    var manualAddButtonDisabled = state.manualAddLoading ? ' disabled aria-disabled="true"' : '';
    var emailCaptureButtonLabel = state.emailCaptureLoading ? 'Submitting...' : 'Reserve your gift';
    var emailCaptureButtonDisabled = state.emailCaptureLoading ? ' disabled aria-disabled="true"' : '';
    var emailCaptureInputDisabled = state.emailCaptureLoading ? ' disabled aria-disabled="true"' : '';
    var originalPriceHtml = state.freebieOriginalPriceLabel
      ? '<span class="freebie-original-price">' + state.freebieOriginalPriceLabel + '</span>'
      : '';
    var rowMode = !hasEmail && lockedEmailCapturePending ? 'locked-email' : 'manual-add';
    var rowRenderKey = [
      PENDING_ROW_TEMPLATE_VERSION,
      rowMode,
      state.manualAddLoading ? '1' : '0',
      state.emailCaptureLoading ? '1' : '0',
      freebieTitle,
      freebieVendor,
      freebieImageSrc,
      state.freebieOriginalPriceLabel,
    ].join('|');
    var overlayHtml = '';

    if (!hasEmail && lockedEmailCapturePending) {
      overlayHtml =
        '<div class="freebie-pending-overlay freebie-email-capture-overlay">' +
        '<div class="freebie-email-capture-lock" aria-hidden="true">' +
        '<svg viewBox="0 0 24 24" width="18" height="18" focusable="false" aria-hidden="true">' +
        '<path fill="currentColor" d="M17 10V7a5 5 0 0 0-10 0v3H5a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2h-2zm-8 0V7a3 3 0 0 1 6 0v3H9z"></path>' +
        '</svg>' +
        '</div>' +
        '<p class="freebie-manual-add-message freebie-email-capture-message">A handcrafted gift, with your order.</p>' +
        '<div class="freebie-email-capture-form" role="group" aria-label="Reserve your gift">' +
        '<input type="email" class="freebie-email-capture-input" placeholder="Enter your email" autocomplete="email" form="freebie-email-detached-form"' +
        emailCaptureInputDisabled +
        '>' +
        '<button type="button" class="freebie-email-capture-submit"' +
        emailCaptureButtonDisabled +
        '>' +
        emailCaptureButtonLabel +
        '</button>' +
        '<p class="freebie-email-capture-error" aria-live="polite"></p>' +
        '</div>' +
        '</div>';
    } else {
      overlayHtml =
        '<div class="freebie-pending-overlay">' +
        '<button type="button" class="freebie-manual-add-button"' +
        manualAddButtonDisabled +
        '>' +
        manualAddButtonLabel +
        '</button>' +
        '<p class="freebie-manual-add-message">Your gift will be set aside.</p>' +
        '</div>';
    }

    var mediaHtml = freebieImageSrc
      ? '<a href="' +
        FREEBIE_PATH +
        '" class="cart-item__image-container global-media-settings">' +
        '<img src="' +
        freebieImageSrc +
        '" class="cart-item__image" alt="' +
        freebieTitle +
        '" loading="lazy" width="150" height="225">' +
        '</a>'
      : '<div class="cart-item__image-container global-media-settings freebie-pending-image-placeholder"></div>';

    tableBodies.forEach(function (tbody) {
      var row = tbody.querySelector('.freebie-pending-line');
      if (!row) {
        row = document.createElement('tr');
        row.className = 'cart-item freebie-pending-line';
      }

      if (row.getAttribute('data-freebie-render-key') === rowRenderKey) {
        return;
      }

      row.setAttribute('data-freebie-render-key', rowRenderKey);

      row.innerHTML =
        '<td class="cart-item__media" role="cell" headers="CartDrawer-ColumnProduct">' +
        '<div class="freebie-pending-blur">' + mediaHtml + '</div>' +
        '</td>' +
        '<td class="cart-item__details" role="cell" headers="CartDrawer-ColumnProduct">' +
        overlayHtml +
        '<div class="freebie-pending-blur">' +
        '<p class="caption-with-letter-spacing">' +
        freebieVendor +
        '</p>' +
        '<a href="' +
        FREEBIE_PATH +
        '" class="cart-item__name h4 break">' +
        freebieTitle +
        '</a>' +
        '</div>' +
        '</td>' +
        '<td class="cart-item__totals right" role="cell" headers="CartDrawer-ColumnTotal">' +
        '<div class="freebie-pending-blur"><div class="cart-item__price-wrapper freebie-pending-price-wrapper">' +
        originalPriceHtml +
        '<span class="price price--end">Rs. 0.00</span>' +
        '</div></div>' +
        '</td>' +
        '<td class="cart-item__quantity" role="cell" headers="CartDrawer-ColumnQuantity">' +
        '<div class="freebie-pending-blur"><div class="cart-item__quantity-wrapper quantity-popover-wrapper">' +
        '<quantity-input class="quantity cart-quantity">' +
        '<button class="quantity__button" name="minus" type="button" disabled aria-disabled="true"><span class="svg-wrapper">-</span></button>' +
        '<input class="quantity__input" type="number" value="1" readonly disabled aria-label="' +
        freebieTitle +
        ' quantity">' +
        '<button class="quantity__button" name="plus" type="button" disabled aria-disabled="true"><span class="svg-wrapper">+</span></button>' +
        '</quantity-input>' +
        '<div class="button button--tertiary cart-remove-button-placeholder" aria-disabled="true"><span class="svg-wrapper">x</span></div>' +
        '</div>' +
        '</div>' +
        '</td>';

      if (!row.parentNode) {
        tbody.appendChild(row);
      }
    });
  }

  function hasDomFreebieRow() {
    var rows = Array.prototype.slice.call(document.querySelectorAll('.cart-item'));
    return rows.some(function (row) {
      return isFreebieRowElement(row);
    });
  }

  async function verifyDrawerFreebieConsistency() {
    if (window.location.pathname === '/cart') return;

    try {
      var cart = await fetchCart();
      var freebieLines = getFreebieLines(cart);
      var clothingQuantity = countNonFreebieItems(cart);
      var domHasFreebie = hasDomFreebieRow();
      var hasOnlyFreebies = cart.items.length > 0 && freebieLines.length === cart.items.length;

      if (freebieLines.length > 0 && (clothingQuantity === 0 || hasOnlyFreebies)) {
        scheduleFreebieSync('consistency: remove orphan freebie', true);
        return;
      }

      if (freebieLines.length === 0 && domHasFreebie) {
        var published = false;
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
          try {
            await publish(PUB_SUB_EVENTS.cartUpdate, { source: 'freebie-manager' });
            published = true;
          } catch (publishError) {
            console.warn('Freebie: consistency publish failed, using fallback refresh', publishError);
          }
        }

        if (!published) {
          await refreshCartUiAfterSync();
        }

        applyFreebieQuantityLocks();
      }
    } catch (error) {
      console.warn('Freebie: consistency check failed', error);
    }
  }

  async function requestCartUiRefresh() {
    var published = false;
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      try {
        await publish(PUB_SUB_EVENTS.cartUpdate, { source: 'freebie-manager' });
        published = true;
      } catch (error) {
        console.warn('Freebie: pubsub cart refresh failed, using fallback refresh', error);
      }
    }

    if (!published) {
      await refreshCartUiAfterSync();
    }

    setTimeout(function () {
      verifyDrawerFreebieConsistency();
    }, published ? 140 : 80);

    setTimeout(function () {
      verifyDrawerFreebieConsistency();
    }, 420);
  }

  function applyFreebieQuantityLocks() {
    moveFreebieRowsToBottom();
    ensurePendingFreebieRows();

    var rows = Array.prototype.slice.call(document.querySelectorAll('.cart-item'));

    rows.forEach(function (row) {
      var isFreebieRow = isFreebieRowElement(row);

      row.classList.toggle('freebie-line-item', Boolean(isFreebieRow));

      if (!isFreebieRow) {
        var existingNote = row.querySelector('.freebie-auto-note');
        if (existingNote) {
          existingNote.remove();
        }
        return;
      }

      row.querySelectorAll('.quantity__button, .quantity__input').forEach(function (control) {
        control.setAttribute('disabled', 'disabled');
        if (control.tagName === 'INPUT') {
          control.setAttribute('readonly', 'readonly');
        }
      });

      var priceWrapper = row.querySelector('.cart-item__price-wrapper');
      if (priceWrapper) {
        var strikePrice = priceWrapper.querySelector('.freebie-original-price');

        if (state.freebieOriginalPriceLabel) {
          if (!strikePrice) {
            strikePrice = document.createElement('span');
            strikePrice.className = 'freebie-original-price';
          }

          strikePrice.textContent = state.freebieOriginalPriceLabel;

          var currentPrice = priceWrapper.querySelector('.price');
          if (currentPrice) {
            priceWrapper.insertBefore(strikePrice, currentPrice);
          } else if (!strikePrice.parentNode) {
            priceWrapper.appendChild(strikePrice);
          }
        } else if (strikePrice) {
          strikePrice.remove();
        }
      }

      var wrapper = row.querySelector('.cart-item__quantity-wrapper');
      if (wrapper) {
        var note = wrapper.querySelector('.freebie-auto-note');
        if (note) {
          note.remove();
        }
      }
    });
  }

  async function syncFreebieQuantity(reason, providedCart) {
    if (state.syncInProgress) {
      state.syncQueued = true;
      return;
    }

    state.syncInProgress = true;
    var didMutate = false;

    try {
      var cart = providedCart || (await fetchCart());
      var freebieLines = getFreebieLines(cart);
      var clothingQuantity = countNonFreebieItems(cart);
      var hasEmail = hasUnlockEmail();
      var desiredFreebieQuantity = hasEmail ? clothingQuantity : 0;
      var hasOnlyFreebies = cart.items.length > 0 && freebieLines.length === cart.items.length;
      var requiresManualAdd = hasEmail && clothingQuantity > 0 && freebieLines.length === 0 && !state.manualAddConfirmed;

      if (!hasEmail) {
        setManualAddConfirmed(false);
      }

      if (freebieLines.length > 0) {
        setManualAddConfirmed(true);
      }

      if (clothingQuantity === 0 && freebieLines.length === 0) {
        setManualAddConfirmed(false);
      }

      state.lastClothingQuantity = clothingQuantity;

      // If cart only has freebies left, clear the entire cart so it becomes empty.
      // Using /cart/clear.js is more reliable than line-key removal which can fail
      // after the DOM has already been mutated by cart.js's section renderer.
      if (hasOnlyFreebies && freebieLines.length > 0) {
        await cartMutation('/cart/clear.js', {});
        didMutate = true;
        setManualAddConfirmed(false);
        state.lastClothingQuantity = 0;
      } else if (freebieLines.length === 0) {
        if (desiredFreebieQuantity > 0 && !requiresManualAdd) {
          var freebieVariantId = await getFreebieVariantId();

          if (freebieVariantId) {
            await cartMutation('/cart/add.js', {
              items: [
                {
                  id: freebieVariantId,
                  quantity: desiredFreebieQuantity,
                },
              ],
            });
            didMutate = true;
          }
        }
      } else {
        if (desiredFreebieQuantity <= 0) {
          if (await removeFreebieLines(freebieLines)) {
            didMutate = true;
          }
        } else {
          var primaryLine = freebieLines[0];
          var extraLines = freebieLines.slice(1);

          if (extraLines.length) {
            await removeFreebieLines(extraLines);
            didMutate = true;
          }

          var currentQty = primaryLine.item.quantity;
          if (currentQty !== desiredFreebieQuantity) {
            await setFreebieLineQuantity(primaryLine, desiredFreebieQuantity);
            didMutate = true;
          }
        }
      }
    } catch (error) {
      console.warn('Freebie: sync failed (' + reason + ')', error);
    } finally {
      state.syncInProgress = false;
      state.manualAddLoading = false;
      state.emailCaptureLoading = false;
    }

    if (didMutate) {
      await requestCartUiRefresh();
    }

    applyFreebieCardState();
    applyFreebieQuantityLocks();

    if (state.syncQueued) {
      state.syncQueued = false;
      scheduleFreebieSync('queued');
    }
  }

  function installFetchWatcher() {
    if (window.__freebieFetchWatcherInstalled) {
      return;
    }

    window.__freebieFetchWatcherInstalled = true;

    var currentFetch = window.fetch.bind(window);

    window.fetch = function () {
      var args = Array.prototype.slice.call(arguments);
      var requestUrl = getRequestUrl(args[0]);
      var shouldWatch = isCartMutationUrl(requestUrl);

      if (shouldWatch && state.internalMutations === 0 && hasUnlockEmail() && !state.manualAddConfirmed) {
        if (requestUrl.indexOf('/cart/add') !== -1) {
          state.lastClothingQuantity = Math.max(1, state.lastClothingQuantity);
          applyFreebieCardState();
        }
      }

      var responsePromise = currentFetch.apply(window, args);

      if (shouldWatch && state.internalMutations === 0) {
        responsePromise.finally(function () {
          scheduleFreebieSync('cart mutation', true);
        });
      }

      return responsePromise;
    };
  }

  function startCartLockObserver() {
    if (state.lockObserver) {
      state.lockObserver.disconnect();
    }

    state.lockObserver = new MutationObserver(function () {
      if (state.lockRaf) return;

      state.lockRaf = requestAnimationFrame(function () {
        state.lockRaf = null;
        applyFreebieQuantityLocks();

        // Cart sections are often replaced in multiple DOM operations; run one
        // delayed pass to catch the settled DOM and avoid rows appearing only
        // after a manual click/focus interaction.
        clearTimeout(state.lockSettleTimer);
        state.lockSettleTimer = setTimeout(function () {
          applyFreebieQuantityLocks();
        }, 140);
      });
    });

    state.lockObserver.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  function startCollectionObserver() {
    if (!window.location.pathname.includes('/collections/')) {
      return;
    }

    if (state.observer) {
      state.observer.disconnect();
    }

    var target = document.querySelector('#ProductGridContainer') || document.querySelector('main') || document.body;

    state.observer = new MutationObserver(function () {
      applyFreebieCardState();
    });

    state.observer.observe(target, {
      childList: true,
      subtree: true,
    });
  }

  function initFreebieManager() {
    state.manualAddConfirmed = getStoredManualAddConfirmed();
    captureFreebiePreviewFromDom();
    primeFreebiePreviewData();

    installFetchWatcher();

    document.addEventListener('click', onFreebieCardClick, true);
    document.addEventListener('click', onInlineFreebieEmailClick, true);
    document.addEventListener('keydown', onInlineFreebieEmailKeydown, true);

    window.addEventListener('email-updated', function () {
      applyFreebieCardState();
      scheduleFreebieSync('email updated', true);
    });

    window.addEventListener('storage', function (event) {
      if (EMAIL_KEYS.indexOf(event.key) > -1) {
        applyFreebieCardState();
        scheduleFreebieSync('storage updated', true);
      }
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (event && event.source === 'freebie-manager') {
          return;
        }
        // Use cartData from the event directly when available — avoids an extra
        // network round-trip and ensures we act on the freshest server state.
        if (event && event.cartData && event.cartData.items) {
          clearTimeout(state.syncTimer);
          syncFreebieQuantity('pubsub cart update', event.cartData);
        } else {
          scheduleFreebieSync('pubsub cart update', true);
        }
      });
    }

    // Fallback: catch remove / quantity-decrement clicks in case the fetch
    // watcher misses a mutation (e.g. due to fetch-chain ordering).
    document.addEventListener('click', function (event) {
      var target = event.target;
      var isRemoveBtn = Boolean(target.closest('cart-remove-button'));
      var isMinusBtn = Boolean(
        target.closest('.quantity__button') &&
          (target.getAttribute('name') === 'minus' ||
            (target.closest('.quantity__button') && target.closest('.quantity__button').getAttribute('name') === 'minus'))
      );
      if (isRemoveBtn || isMinusBtn) {
        setTimeout(function () {
          scheduleFreebieSync('remove click fallback', true);
        }, 400);
        setTimeout(function () {
          scheduleFreebieSync('remove click retry', true);
        }, 1200);
      }
    });

    window.addEventListener('pageshow', function () {
      scheduleFreebieSync('pageshow', true);
    });

    window.addEventListener('focus', function () {
      scheduleFreebieSync('window focus', true);
    });

    document.addEventListener('cart:refresh', function () {
      applyFreebieQuantityLocks();
      scheduleFreebieSync('cart refresh', true);
    });

    applyFreebieCardState();
    applyFreebieQuantityLocks();
    startCartLockObserver();
    startCollectionObserver();

    scheduleFreebieSync('init', true);
    setTimeout(function () {
      scheduleFreebieSync('post-init', true);
    }, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFreebieManager);
  } else {
    initFreebieManager();
  }
})();
